// ---------- installation et hors-ligne (web uniquement) ----------
// Enregistre le service worker émis par le build (swPlugin, vite.config.ts) : c'est lui qui rend
// la version web installable et jouable sans réseau. Repris de Codigrid, qui a payé pour
// apprendre les deux règles qui comptent :
//  - le nouveau worker ne prend JAMAIS la main tout seul (cf. `install` dans sw.js) : le bundle
//    est découpé, et une page ouverte peut encore charger un morceau de l'ancien build ;
//  - donc on PROPOSE la mise à jour, sinon un joueur qui ne ferme jamais l'onglet resterait
//    indéfiniment sur le build qu'il a ouvert.

import { t } from './i18n';
import { isNative } from './platform';

const CHECK_MS = 30 * 60_000;
const MIN_GAP_MS = 5 * 60_000;
let lastCheck = Date.now();
let offered = false;

function check(reg: ServiceWorkerRegistration): void {
  const now = Date.now();
  if (now - lastCheck < MIN_GAP_MS) return;
  lastCheck = now;
  void reg.update().catch(() => {
    /* hors ligne : la vérification suivante fera le travail */
  });
}

function offer(waiting: ServiceWorker): void {
  if (offered) return;
  offered = true;
  const bar = document.createElement('div');
  bar.className = 'update';
  bar.setAttribute('role', 'status');
  bar.innerHTML = `<span>${t('update.text')}</span><button class="btn btn-big" type="button">${t('update.now')}</button>`;
  document.body.append(bar);
  const btn = bar.querySelector('button')!;
  btn.onclick = () => {
    btn.disabled = true;
    btn.textContent = t('update.reloading');
    let done = false;
    const reload = (): void => {
      if (done) return;
      done = true;
      location.reload();
    };
    navigator.serviceWorker.addEventListener('controllerchange', reload);
    waiting.postMessage({ type: 'SKIP_WAITING' });
    window.setTimeout(reload, 2500); // le worker a pu disparaître entre-temps : on recharge quand même
  };
}

function watch(reg: ServiceWorkerRegistration): void {
  if (reg.waiting && navigator.serviceWorker.controller) offer(reg.waiting);
  reg.addEventListener('updatefound', () => {
    const sw = reg.installing;
    sw?.addEventListener('statechange', () => {
      if (sw.state === 'installed' && navigator.serviceWorker.controller) offer(sw);
    });
  });
}

/** Ni dans l'APK (ses fichiers sont déjà locaux), ni en dev (le worker masquerait le HMR). */
export function initPWA(): void {
  if (isNative() || !import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register(new URL('sw.js', document.baseURI), { updateViaCache: 'none' })
      .then((reg) => {
        watch(reg);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') check(reg);
        });
        window.setInterval(() => check(reg), CHECK_MS);
      })
      .catch(() => {
        /* refusé (navigation privée) : le jeu marche sans */
      });
  });
}
